module.exports = __webpack_public_path__ + "img/Mask_1.8ee0b111.png";